import { createSlice } from "@reduxjs/toolkit";

const TableSlice = createSlice({
  name: "tableofcontent",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    TableStart: (state) => {
      state.loading = true;
    },
    TableSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    TableFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { TableStart, TableSuccess, TableFailure } = TableSlice.actions;

export default TableSlice.reducer;
